import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table table-bordered" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, " Период "),
  /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, " Техника "),
  /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, " Клиента "),
  /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, " Вид ремонта "),
  /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, " Примечание "),
  /*#__PURE__*/_createElementVNode("th", { class: "p-2" })
], -1)
const _hoisted_3 = { class: "p-2" }
const _hoisted_4 = { class: "p-2" }
const _hoisted_5 = { class: "p-2" }
const _hoisted_6 = { class: "p-2" }
const _hoisted_7 = { class: "p-2" }
const _hoisted_8 = { class: "p-2 text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_modal_ui = _resolveComponent("modal-ui")!

  return (_openBlock(), _createBlock(_component_modal_ui, {
    id: _ctx.id,
    size: "modal-lg",
    title: "Список секций"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("table", _hoisted_1, [
          _hoisted_2,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (i) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: i.id
            }, [
              _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.moment(i.dateStart).locale('ru').format('DD.MM.YYYY')) + " - " + _toDisplayString(_ctx.moment(i.dateEnd).locale('ru').format('DD.MM.YYYY')), 1),
              _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.getLoco(i.locoModelId)), 1),
              _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.getContractor(i.contractorId)), 1),
              _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.getJob(i.jobCategoryId)), 1),
              _createElementVNode("td", _hoisted_7, _toDisplayString(i.comment), 1),
              _createElementVNode("td", _hoisted_8, [
                _createVNode(_component_button_ui, {
                  "button-class": "btn-danger btn-sm ms-3",
                  onClick: ($event: any) => (_ctx.removeHandler(i.id))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Удалить ")
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["id"]))
}